import { useSettings } from "@/context/SettingsContext";
import { Button } from "@/components/ui/button";
import { Sprout, Copy, Search, X, Carrot } from "lucide-react";

const STEPS = [
  { icon: Sprout, title: "Plant a Root", desc: "Describe a task — Carrot mints a short, unique code (a Root) for it." },
  { icon: Copy, title: "Spread it", desc: "Paste the Root wherever the work lives — Slack, email, a doc." },
  { icon: Search, title: "Pull it back", desc: "Search the Root in any app to jump straight back to the work." },
];

export default function WelcomeCard() {
  const { settings, saveSettings, loaded } = useSettings();

  if (!loaded || settings?.welcome_dismissed) return null;

  const dismiss = () => saveSettings({ ...settings, welcome_dismissed: true });

  return (
    <div
      data-testid="welcome-card"
      className="relative mb-6 rounded-2xl border border-primary/20 bg-gradient-to-br from-primary/[0.07] to-transparent p-5 sm:p-6"
    >
      <button
        onClick={dismiss}
        data-testid="welcome-dismiss-btn"
        aria-label="Dismiss welcome"
        className="absolute top-3 right-3 h-8 w-8 inline-flex items-center justify-center rounded-full text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
      >
        <X className="w-4 h-4" />
      </button>

      <div className="flex items-center gap-2 mb-1">
        <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center shrink-0">
          <Carrot className="w-4 h-4 text-white" />
        </div>
        <h2 className="text-lg font-extrabold tracking-tight">Welcome to Carrot 🥕</h2>
      </div>
      <p className="text-sm text-muted-foreground max-w-xl">
        This list is your <span className="font-semibold text-foreground">Field</span> — everything you still need to
        do. Here's the idea in three steps:
      </p>

      <div className="grid sm:grid-cols-3 gap-3 mt-4">
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div key={i} className="rounded-xl border border-border bg-card p-3.5">
              <div className="flex items-center gap-2 mb-1">
                <Icon className="w-4 h-4 text-primary shrink-0" />
                <span className="text-sm font-bold">{s.title}</span>
              </div>
              <p className="text-xs text-muted-foreground leading-relaxed">{s.desc}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-4">
        <Button
          onClick={dismiss}
          data-testid="welcome-got-it-btn"
          className="rounded-full bg-primary hover:bg-[#E85D04] text-white font-semibold"
        >
          Got it — let's plant one
        </Button>
      </div>
    </div>
  );
}
